class ProductCardCart {
  constructor() {
    this.cart = {}; 
    this.isFetching = false;
    console.log("ProductCardCart: Initializing...");
    
    // 1. Initial Load
    this.init();

    // 2. Global Event Listeners
    this.bindEvents();
    
    // 3. Monitor Network Requests (Syncs Sidebar changes to Product Cards)
    this.monitorNetworkRequests();
  }

  async init() {
    if (this.isFetching) return;
    this.isFetching = true;

    await this.fetchCart();
    this.updateAllCards();
    
    this.isFetching = false;
  }

  // --- 1. DATA LOGIC ---
  async fetchCart() {
    try {
      const response = await fetch('/cart.js?_=' + new Date().getTime());
      const cart = await response.json();
      this.cart = {};
      cart.items.forEach(item => {
        this.cart[item.id] = item.quantity;
      });
      console.log("ProductCardCart: Cart state updated", this.cart);
    } catch (error) {
      console.error('ProductCardCart: Error fetching cart:', error);
    }
  }

  // --- 2. UI UPDATE LOGIC ---
  updateAllCards() {
    const wrappers = document.querySelectorAll('.dynamic-cart-btns');
    wrappers.forEach(wrapper => this.updateCardState(wrapper));
  }

  updateCardState(wrapper) {
    if (!wrapper) return;
    const variantId = parseInt(wrapper.dataset.variantId);
    if (!variantId) return;

    const qtyInCart = this.cart[variantId] || 0;

    const addBtn = wrapper.querySelector('.btn-add-to-cart');
    const qtyWrapper = wrapper.querySelector('.qty-control-wrapper');
    const input = wrapper.querySelector('.qty-input');

    this.setLoading(wrapper, false);

    if (qtyInCart > 0) {
      if(addBtn) addBtn.classList.add('hidden');
      if(qtyWrapper) qtyWrapper.classList.remove('hidden');
      if(input) input.value = qtyInCart;
    } else {
      if(addBtn) addBtn.classList.remove('hidden');
      if(qtyWrapper) qtyWrapper.classList.add('hidden');
      if(input) input.value = 0;
    }
  }

  // --- 3. EVENT HANDLERS ---
  bindEvents() {
    document.addEventListener('click', (e) => {
      // Add to Cart
      const addBtn = e.target.closest('.btn-add-to-cart');
      if (addBtn) {
        e.preventDefault(); e.stopPropagation();
        this.handleAddToCart(addBtn.closest('.dynamic-cart-btns'));
        return;
      }
      // Plus
      const plusBtn = e.target.closest('.btn-plus');
      if (plusBtn) {
        e.preventDefault(); e.stopPropagation();
        this.handleQuantityChange(plusBtn.closest('.dynamic-cart-btns'), 1);
        return;
      }
      // Minus
      const minusBtn = e.target.closest('.btn-minus');
      if (minusBtn) {
        e.preventDefault(); e.stopPropagation();
        this.handleQuantityChange(minusBtn.closest('.dynamic-cart-btns'), -1);
        return;
      }
    });

    this.observeVariantChanges();
  }

  monitorNetworkRequests() {
    const originalFetch = window.fetch;
    const _this = this;
    window.fetch = function() {
      return originalFetch.apply(this, arguments).then((response) => {
        if (response.url.includes('/cart/add') || 
            response.url.includes('/cart/change') || 
            response.url.includes('/cart/update')) {
          // If external script updates cart, refresh our cards
          setTimeout(() => { _this.init(); }, 500);
        }
        return response;
      });
    };
  }

  observeVariantChanges() {
    const attachObserver = () => {
      const hiddenInputs = document.querySelectorAll('input.product-variant-id');
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
             const wrapper = mutation.target.closest('form').querySelector('.dynamic-cart-btns');
             if (wrapper) {
               wrapper.dataset.variantId = mutation.target.value;
               this.updateCardState(wrapper);
             }
          }
        });
      });
      hiddenInputs.forEach(input => observer.observe(input, { attributes: true }));
    };

    attachObserver();
    // Re-attach when new sections load (like filter page)
    document.addEventListener('shopify:section:load', attachObserver);
  }

  // --- 4. CART ACTIONS ---
  async handleAddToCart(wrapper) {
    if(!wrapper) return;
    const variantId = parseInt(wrapper.dataset.variantId);
    this.setLoading(wrapper, true);

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });

      if (res.ok) {
        this.cart[variantId] = (this.cart[variantId] || 0) + 1;
        this.updateCardState(wrapper);
        // FORCE DRAWER UPDATE
        this.refreshCartDrawer(); 
      } else {
        this.setLoading(wrapper, false);
      }
    } catch (err) {
      console.error(err);
      this.setLoading(wrapper, false);
    }
  }

  async handleQuantityChange(wrapper, delta) {
    const variantId = parseInt(wrapper.dataset.variantId);
    const currentQty = this.cart[variantId] || 0;
    const newQty = currentQty + delta;
    this.setLoading(wrapper, true);

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId.toString(), quantity: newQty })
      });

      if (res.ok) {
        if (newQty <= 0) delete this.cart[variantId];
        else this.cart[variantId] = newQty;
        
        this.updateCardState(wrapper);
        // FORCE DRAWER UPDATE
        this.refreshCartDrawer();
      } else {
         this.setLoading(wrapper, false);
      }
    } catch (err) {
      console.error(err);
      this.setLoading(wrapper, false);
    }
  }

  // --- 5. THE MAGIC DRAWER SYNC ---
  async refreshCartDrawer() {
    // We fetch the header section. In your theme, 'cart-icon-bubble' contains the dropdown.
    try {
      const res = await fetch('/?sections=cart-icon-bubble');
      const data = await res.json();
      
      const newHtml = data['cart-icon-bubble'];
      const targetElement = document.getElementById('cart-icon-bubble');

      if (targetElement && newHtml) {
        // Parse the string to a node
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = newHtml;

        const newContent = tempDiv.querySelector('#cart-icon-bubble');
        if (newContent) {
            targetElement.replaceWith(newContent);
        } else {
            targetElement.innerHTML = newHtml;
        }

        // --- NEW: Add Animation Class ---
        // Find the newly inserted .wbhcart element
        const cartElement = document.querySelector('.wbhcart');
        cartElement.classList.remove('animate-added');
        if (cartElement) {
            cartElement.classList.add('animate-added');
        }

        // Trigger your theme's dropdown open logic if needed
        const cartDropdown = document.getElementById('cart-icon-bubble');
        if(cartDropdown) {
             const dropdownMenu = cartDropdown.querySelector('.dropdown-menu');
             // Optional: if(dropdownMenu) dropdownMenu.classList.add('show');
        }
      }
    } catch (e) {
      console.error("Failed to refresh cart drawer", e);
    }
  }

  setLoading(wrapper, isLoading) {
    const spinners = wrapper.querySelectorAll('.loading-overlay__spinner');
    spinners.forEach(s => {
      if(isLoading) s.classList.remove('hidden');
      else s.classList.add('hidden');
    });
  }
}

if (!window.productCardCart) {
  window.productCardCart = new ProductCardCart();
}